document.addEventListener('DOMContentLoaded', function() {
    const sizeChartButton = document.getElementById('size-chart-button');
    const sizeChartDrawer = document.querySelector('.size-guide-drawer[data-match="true"]') || document.querySelector('.size-guide-drawer');
    const sizeGuideDrawers = document.querySelectorAll('.size-guide-drawer');
    const sizeChartOverlay = document.getElementById('size-chart-overlay');
    const sizeGuideHeader = sizeChartDrawer.querySelector('.size-guide__header');
    const closeDrawerMob = sizeChartDrawer.querySelector('.close-drawer-mob');
    const mainHeader = document.getElementById('shopify-section-header');
    const cmButton = sizeChartDrawer.querySelector('#cm-button');
    const inButton = sizeChartDrawer.querySelector('#in-button');
    const sizeCollapse = document.querySelector('.tab-wrapper .size a');

    let allMatchFalse = true;
    sizeGuideDrawers.forEach(function(drawer) {
        if (drawer.getAttribute('data-match') !== 'false') {
            allMatchFalse = false;
        }
    });

    if (allMatchFalse) {
        sizeChartButton.style.display = 'none';
        sizeCollapse.style.display = 'none';
    }

    function openDrawer() {
        sizeChartDrawer.style.display = 'block';
        setTimeout(() => {
            sizeChartDrawer.classList.add('sizechart-drawer-open');
        }, 10);
        sizeChartOverlay.classList.add('show');
        sizeChartOverlay.style.display = 'block';
        mainHeader.style.zIndex = '1';
        document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
        sizeChartDrawer.classList.remove('sizechart-drawer-open');
        sizeChartDrawer.classList.add('sizechart-drawer-close');
        sizeChartOverlay.classList.remove('show');
        setTimeout(() => {
            sizeChartDrawer.style.display = 'none';
            sizeChartOverlay.style.display = 'none';
            sizeChartDrawer.classList.remove('sizechart-drawer-close');
        }, 300);
        mainHeader.style.zIndex = '';
        document.body.style.overflow = '';
    }

    sizeChartButton.addEventListener('click', openDrawer);
    sizeCollapse.addEventListener('click', openDrawer);

    sizeChartOverlay.addEventListener('click', closeDrawer);
    sizeGuideHeader.addEventListener('click', closeDrawer);
    closeDrawerMob.addEventListener('click', closeDrawer);
    
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            closeDrawer();
        }
    });

    function changeUnit(unit) {
    var sizeTable = document.querySelector('.size-table');
    var rows = sizeChartDrawer.querySelectorAll('.size-table-row');
    rows.forEach(function(row, rowIndex) {
        
        if (row.getAttribute('data-index') === '1') {
            return;
        }

        var cells = row.querySelectorAll('.size-table-cell');
        var excludeRow = Array.from(cells).some(function(cell) {
            var cellContent = cell.textContent.trim().toLowerCase();
            return cellContent === "eu size" || cellContent === "uk size" || cellContent === "us size";
        });
        
        if (!excludeRow) {
            cells.forEach(function(cell, cellIndex) {
                if (rowIndex !== 0 && cellIndex !== 0) {
                    if (unit === 'cm') {
                        cell.textContent = cell.getAttribute('data-cm');
                    } else {
                        cell.textContent = cell.getAttribute('data-inch');
                    }
                }
            });
        }
    });

    if (unit === 'cm') {
        cmButton.classList.add('active');
        inButton.classList.remove('active');
    } else {
        cmButton.classList.remove('active');
        inButton.classList.add('active');
    }
    }

    cmButton.addEventListener('click', function() {
        changeUnit('cm');
    });

    inButton.addEventListener('click', function() {
        changeUnit('inch');
    });

    changeUnit('cm');
});


document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a');
    links.forEach(link => {
        if (link.textContent.trim() === 'Take Size Quiz') {
            link.classList.add('easysize-widget');
        }
    });
});